
function getStatusResources(order,orderRt,store,strings,imagePath){
  const isDelivery = order.type === "delivery" 
  const isLocal = order.type==="AUTO"
  const isTakeaway = order.type==="takeaway"


  const request = `${imagePath}/wm_request.svg`;
  const cooking = `${imagePath}/wm_cooking.svg`;
  const done = `${imagePath}/wm_done.svg`
  const delivering =  `${imagePath}/wm_delivering.svg`
  const delivered = `${imagePath}/wm_delivered.svg`;
  const rejected = `${imagePath}/wm_status_rejected.svg`;

  let requestProgress =  `${imagePath}/wm_status_request.svg`;
  let requestReviewed = `${imagePath}/wm_status_reviewed.svg`;
  let cookingProgress = `${imagePath}/wm_status_cooking.svg`;
  let doneProgress = `${imagePath}/wm_status_delivering.svg`;
  let deliveredProgress = `${imagePath}/wm_status_delivered.svg`;

  const  urlBackground = `${imagePath}/wm_ticket.svg`;

  if(!isDelivery){
     requestProgress =  `${imagePath}/wm_status_request_package.svg`;
     requestReviewed = `${imagePath}/wm_status_reviewed_package.svg`;
     cookingProgress = `${imagePath}/wm_status_cooking_package.svg`;
     doneProgress = `${imagePath}/wm_status_done_package.svg`;
     deliveredProgress = `${imagePath}/wm_status_delivered_package.svg`;
  }

  const statusRt = orderRt.status;

  let res;
  if (statusRt === "REQUEST") {
    res = {
      status: request,
      progress: requestProgress,
      warning: strings.ticket_request_link.replace("%s", strings.action_send_to_whatsapp.toUpperCase()),
      message: strings.ticket_request_pending.replace("${location}", store.name.toUpperCase()),
      animation: 'request-status', 
      background:urlBackground
    }

    if(isLocal){
        res.warning=null; 
        res.message=strings.ticket_request_pending_local; 
    }

  } else if (statusRt === "NEW") {
    res = {
      status: request,
      progress: requestReviewed,
      message: strings.ticket_request_reviewed,
      animation: 'request-status',
      background:urlBackground
    }

    if(isLocal){
        res.warning=null; 
        res.message=strings.ticket_request_pending_local; 
    }

  } else if (statusRt === "DOING") {
    res = {
      status: cooking,
      progress: cookingProgress,
      message: strings.ticket_request_cooking,
      animation: 'cooking-status', 
      background:urlBackground
    }
  } else if (statusRt === "DONE") {
    res = {
      status: cooking,
      progress: cookingProgress,
      message: strings.ticket_request_cooking,
      animation: 'cooking-status', 
      background:urlBackground
    }

    if(isLocal|| isTakeaway){
      res.status = done; 
      res.progress= doneProgress; 
      res.message=strings.ticket_request_ready;
      res.animation='done-status'; 
    }

  } else if (statusRt === "DELIVERING") {
    res = {
      status: delivering,
      progress: doneProgress,
      message: strings.ticket_request_delivering,
      animation: 'delivering-status', 
      background:urlBackground
    }

    if(isLocal|| isTakeaway){
        res.message=strings.ticket_request_ready; 
    }

  } else if (statusRt === "DELIVERED") {
    res = {
      status: delivered,
      progress: deliveredProgress,
      message: strings.ticket_request_delivered, 
      background:urlBackground
    }
  } else if (statusRt === "REJECTED") {
    res = {
      status: rejected,
      message: strings.ticket_request_rejected.replace("${location}", store.name), 
      background:urlBackground
    }
  }

  return res; 

}




export {
        getStatusResources
   };